import * as React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

export interface LinkTileProps {
  className?: string;
  image?: string;
  url: string;
}

export interface LinkTileState {
  /* empty*/
}

export type KeyedElement<T = {}> = React.ReactElement<T & { key: number }>;

export class LinkTile extends React.Component<LinkTileProps, LinkTileState> {
  render() {
    const { className, image, url } = this.props;
    const imageElement = this.getImageElement(image);

    return (
      <Link className={`link-tile ${className || ''}`} to={url}>
        {imageElement}
        {this.getOutsideSlot()}
      </Link>
    );
  }

  private getOutsideSlot = (): React.ReactElement<{}> | null => {
    let slottedChild = null;

    React.Children.forEach(this.props.children, child => {
      if (!React.isValidElement(child)) {
        return;
      }

      if (child.props['data-slot'] === 'outside') {
        slottedChild = React.cloneElement(child);
      }
    });

    return slottedChild;
  };

  private getDefaultSlots = (): Array<KeyedElement> => {
    let slottedChildren: Array<KeyedElement> = [];

    React.Children.forEach(
      this.props.children,
      (child: KeyedElement, index) => {
        if (!React.isValidElement(child)) {
          return;
        }

        if (child.props['data-slot'] !== 'outside') {
          slottedChildren.push(React.cloneElement(child, { key: index }));
        }
      }
    );

    return slottedChildren;
  };

  private getImageElement = (image?: string): JSX.Element | null => {
    return (
      <div className="link-tile-background-image-wrapper">
        <div
          className="link-tile-background-image"
          style={{ backgroundImage: image ? `url("${image}")` : undefined }}
        />
        <span className="link-tile-background-image-overlay" />
        {this.getDefaultSlots()}
      </div>
    );
  };
}

export default LinkTile;



// WEBPACK FOOTER //
// ./src/app/components/Common/LinkTile/index.tsx